import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { projects } from '../data/projects';
import './ProjectDetail.css';

const ProjectDetail = () => {
    const { id } = useParams();
    const project = projects.find(p => p.id === parseInt(id));

    if (!project) {
        return <div className="project-detail-page">Project not found</div>;
    }

    return (
        <div className="project-detail-page">
            <div className="project-header">
                <h1>{project.title}</h1>
                <p className="project-category">{project.category}</p>
            </div>

            <div className="project-content">
                <div className="project-media full-width">
                    <img src={project.coverImage} alt={project.title} className="detail-image" />
                </div>

                <div className="project-description">
                    <p>
                        {project.description}
                    </p>
                </div>

                <div className="project-gallery">
                    <div className="placeholder-media tall">Gallery Image 1</div>
                    <div className="placeholder-media tall">Gallery Image 2</div>
                </div>
            </div>

            <div className="project-navigation">
                <Link to="/" className="back-link">Back to Home</Link>
            </div>
        </div>
    );
};

export default ProjectDetail;
